// extracted by mini-css-extract-plugin
module.exports = {"base":"RoundedButton_base___uvNi","wide":"RoundedButton_wide__oiAe_","narrow":"RoundedButton_narrow__J83Y7"};